import React, {useState, useEffect, useContext, useCallback, useMemo, useRef} from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { formatCurrency} from '@jutro/components';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import PropTypes from 'prop-types';
import { CurrencyValue, useModal } from '@jutro/components';
import { Button } from '@jutro/legacy/components';
import { DocumentDownloadService } from '@xengage/gw-portals-document-js';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { EndorsementService } from 'gw-capability-policychange';
import { UserService } from 'gw-capability-gateway';
import { GatewayDocumentService } from 'gw-capability-gateway-document';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import {
    MLPortalStorageService,
    MLNavigationStepsTrackingService,
    MLStateRolloutService
} from 'ml-services-common-react';
import { useMLLandingPageContext } from 'gw-capability-gateway-quoteandbind-common-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { MLPolicyChangeBtnComponent } from 'ml-capability-policychange-common-react';
import { MLEndorsementFlowUtil, MLLineTypeUtil, MLDisclosureUtil, MLProductCodeUtil } from 'ml-portals-util-js';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import appConfig from 'app-config';

import { PAPolicySummaryComponent } from 'gw-capability-quoteandbind-pa-react';
import { HOPolicySummaryComponent } from 'gw-capability-quoteandbind-ho-react';
import { PUPPolicySummaryComponent } from 'gw-capability-quoteandbind-pup-react';

import { PAPolicyChangeMessages } from 'gw-capability-policychange-pa-react';
import { HOPolicyChangeMessages } from 'gw-capability-policychange-ho-react';
import { PUPPolicyChangeMessages } from 'gw-capability-policychange-pup-react';

import paWizardConfig from '../../../gw-capability-policychange-pa-react/config/pa-policychange-wizard-config.json5';
import hoWizardConfig from '../../../gw-capability-policychange-ho-react/config/ho-wizard-config.json5';
import pupWizardConfig from '../../../gw-capability-policychange-pup-react/config/pup-wizard-config.json5';
import commonPolicyChangeMessages from '../../PolicyChangeCommon.messages';

import metadata from './PolicyChangeSummaryComponent.metadata.json5';
import messages from './PolicyChangeSummaryComponent.messages';
import styles from './PolicyChangeSummaryComponent.module.scss';
import {
    DriverExclusionAgreementPopup,
    DriverExclusionAgreementPopupMessages,
    DriverExclusionAgreementPopupStyles
} from 'ml-capability-quoteandbind-common-react';
import { PolicyChange } from 'gw-capability-policychange-common-react';

import MLCoveragePackageLevelInfoModal from "../../../gw-capability-gateway-quoteandbind-common-react/components/MLCoveragePackageLevelInfoModal/MLCoveragePackageLevelInfoModal";

//US993539
import MLDocumentsUpload from 'gw-capability-gateway-react/Policies/MLDocumentsUploadPopup/GatewayMLDocumentsUploadPopup';
import MLDocumentsUploadPopupMsg from 'gw-capability-gateway-react/Policies/MLDocumentsUploadPopup/MLDocumentsUploadPopup.messages';
import mlDocumentsUploadPopupMetadata from 'gw-capability-gateway-react/Policies/MLDocumentsUploadPopup/MLDocumentsUploadPopup.metadata.json5';

import { IntlContext } from '@jutro/legacy/locale';

const EFFECTIVE_DATE_STATE = '/policychange';
const ADDITIONAL_CHANGES_STATE = '/additonalchanges';
const PA_PAYMENT_STEP = 'PABillingDetailsPagePolChange';
const PA_COVERAGE_STEP = 'endorsementCoverages';
const PA_DRIVERS_STEP = 'endorsementPaListDrivers';
const PA_DRIVER_DISCOVERY_REVIEW_STEP = 'endorsementPaDriverDiscoveryReview';
const PA_VEHICLES_STEP = 'PCPAVehicleListPolChange';
const NON_PA_COVERAGE_STEP = 'CoveragesPage';
const HO_PAYMENT_STEP = 'HOBillingDetailsPagePolChange';
const PUP_PAYMENT_STEP = 'PUPBillingDetailsPagePolChange';
const PA_RENTED_TRAILER_CAMPER_STEP = 'endorsementPaListRentedTrailerCamper'

const {
    ML_STORAGE_KEY_PREVIOUS_PREMIUM,
    httpSettings
} = appConfig;

const { serviceBaseURLs } = httpSettings;

// ================== AMP Steps ======================================================
const stepToDisplayName = {
    '/coverages': messages.coverageDetails,
    '/billing-details': messages.billingDetails,
    '/profiledetails': messages.communicationPreferences,
    '/address': messages.addressDetails,
    '/interesed-parties': messages.interestedPartiesDetails
};

const hoStepToDisplayName = {
    '/discounts': messages.discountDetails,
    '/propertydetails': messages.propertyDetails,
    '/additionalpolicyinfo': messages.additionalPolicyInfo
};

const pupStepToDisplayName = {
    endorsementPupDrivers: messages.driverDetails,
    '/list-ratedvehicleoperator': messages.driverDetails,
    '/vehicles': messages.vehicleDetails,
    '/list-vehicles': messages.vehicleDetails,
    '/watercraft': messages.watercraftExposures,
    '/list-watercraft': messages.watercraftExposures,
    '/locations': messages.locationExposures,
    '/list-locations': messages.locationExposures,
    '/businessactivity': messages.businessActivityDetails,
    '/affiliation': messages.employerGroupAssocDetails,
    '/list-yourpolicies': messages.underlyingPolicyDetails,
    '/additionalpolicyinfo': messages.additionalPolicyInfo
};

const paStepToDisplayName = {
    '/excludeddrivers': messages.excludedDriversDetails,
    '/drivers': messages.driverDetails,
    '/vehicles': messages.vehicleDetails,
    '/policyChangeVehiclesList': messages.listVehicles,
    '/householdmembers': messages.householdMembersDetails,
    '/affiliation': messages.employerGroupAssocDetails,
    '/additionalpolicyinfo': messages.additionalPolicyInfo
};

// ===================================================================================

const stepToMakeMoreChangesLabel = {
    '/coverages': commonPolicyChangeMessages.coverages,
    '/billing-details': commonPolicyChangeMessages.billingDetails,
    '/profiledetails': commonPolicyChangeMessages.communicationPreferences,
    '/address': commonPolicyChangeMessages.addresses,
    '/interested-parties': commonPolicyChangeMessages.interestedParties
};

const hoStepToMakeMoreChangesLabel = {
    '/discounts': HOPolicyChangeMessages.mlDiscounts,
    '/propertydetails': HOPolicyChangeMessages.mlPropertyDetails,
    '/affiliation': HOPolicyChangeMessages.mlEmployersAffiliations,
    '/additionalpolicyinfo': HOPolicyChangeMessages.mlAdditionalPolicyInfo
};

const pupStepToMakeMoreChangesLabel = {
    '/list-ratedvehicleoperator': PUPPolicyChangeMessages.drivers,
    '/list-excludedvehicleoperator': PUPPolicyChangeMessages.excludedDrivers,
    '/list-nondrivingvehicleoperator': PUPPolicyChangeMessages.householdMembers,
    '/list-vehicles': PUPPolicyChangeMessages.vehicles,
    '/list-watercraft': PUPPolicyChangeMessages.watercraft,
    '/locations': PUPPolicyChangeMessages.locations,
    '/list-businessactivity': PUPPolicyChangeMessages.businessActivity,
    '/affiliation': PUPPolicyChangeMessages.employerAffiliation,
    '/additionalpolicyinfo': PUPPolicyChangeMessages.additionalPolicyInfo
};

const paStepToMakeMoreChangesLabel = {
    '/list-excludeddrivers': PAPolicyChangeMessages.mlExcludedDrivers,
    '/list-drivers': PAPolicyChangeMessages.mlDrivers,
    '/driver-discovery-review': PAPolicyChangeMessages.mlDriverDiscoveryReview,
    '/affiliation': PAPolicyChangeMessages.mlEmployerAffiliation,
    '/policyChangeVehiclesList': PAPolicyChangeMessages.mlVehicles,
    '/list-householdmembers': PAPolicyChangeMessages.mlHouseholdMembers,
    '/additionalpolicyinfo': PAPolicyChangeMessages.mlAdditionalPolicyInfo
};

const termTypes = {
    Annual: messages.year,
    HalfYear: messages.sixMonth
};

const PolicyChangeSummaryComponent = (props) => {
    const modalApi = useModal();
    const { 
        endorsementVM, 
        jumpTo, 
        currentSteps, 
        currentStepIndex, 
        changeNextSteps, 
        goNext, 
        onNext, 
        currentStepName, 
        wizardData, 
        updateWizardData, 
        history, 
        saveAndQuoted,
        contingencies,
        refreshPreBindContingencyData,
        isFileUploadDone
    } = props;

    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const intl = useContext(IntlContext);
    const [canAccessGroup, setCanAccessGroup] = useState();
    const { additionalPolicyChangeProps } = useMLLandingPageContext();
    const ML_STORAGE_KEY_SHOW_EXCLUSION_AGREEMENT = "SHOW_EXCLUSION_AGREEMENT"

    const {
        addWarningAlert,
        addSuccessAlert,
        addErrorAlert,
        clearBlockAlerts,
        clearAlerts
    } = MLNotificationBlockUtil();

    const {
        showProgressDialog,
        showErrorModal
    } = MLModalService();

    const getGroupAccessPermission = (policyState) => {
        return MLStateRolloutService.checkIsGroupEnabled(policyState, authHeader);
    };

    if (_.isUndefined(canAccessGroup)) {
        const promise = getGroupAccessPermission(endorsementVM?.value?.baseData?.policyAddress?.state);
        promise.then((isGroupEligible) => {
            isGroupEligible = endorsementVM?.baseData?.producerCodeOfService_ML?.producerType_ML?.value?.code === "ia" ? false : isGroupEligible
            setCanAccessGroup(isGroupEligible);
        });
    }

    const addLOBStepsToDisplayMappings = useCallback(() => {
        if (endorsementVM.value.isHomeOwners()) {
            Object.assign(stepToDisplayName, hoStepToDisplayName);
            Object.assign(stepToMakeMoreChangesLabel, hoStepToMakeMoreChangesLabel);
        } else if (endorsementVM.value.isPersonalUmbrella()) {
            if (!endorsementVM.value.baseData.canExcludeDrivers_ML) {
                Object.assign(stepToDisplayName, pupStepToDisplayName);
                Object.assign(stepToMakeMoreChangesLabel, _.omit(pupStepToMakeMoreChangesLabel, '/list-excludedvehicleoperator'));
            } else {
                Object.assign(stepToDisplayName, pupStepToDisplayName);
                Object.assign(stepToMakeMoreChangesLabel, pupStepToMakeMoreChangesLabel);
            }
        } else if (endorsementVM.value.isPersonalAuto()) {
            if (!endorsementVM.value.baseData.canExcludeDrivers_ML) {
                Object.assign(stepToDisplayName, _.omit(paStepToDisplayName, '/excludeddrivers'));
                Object.assign(stepToMakeMoreChangesLabel, _.omit(paStepToMakeMoreChangesLabel, '/list-excludeddrivers'));
            } else {
                Object.assign(stepToDisplayName, paStepToDisplayName);
                Object.assign(stepToMakeMoreChangesLabel, paStepToMakeMoreChangesLabel);
            }
        } else {
            console.error(new Error('Could not add step labels due to unknown lob type'));
        }
    }, [endorsementVM]);

    const getMoreChangesSelectableSteps = useCallback(() => {
        addLOBStepsToDisplayMappings();
        return Object.keys(stepToMakeMoreChangesLabel).map((stepName) => {
            const isHouseHoldMembersStepName = stepName === '/list-householdmembers';
            const isModernProduct = _.get(endorsementVM, 'isModernProduct_Ext.value', false);
            return {
                path: stepName,
                label: (isHouseHoldMembersStepName && isModernProduct) ? translator(PAPolicyChangeMessages.nonDrivers) : translator(stepToMakeMoreChangesLabel[stepName])
                
            };
        });
    }, [addLOBStepsToDisplayMappings, endorsementVM, translator]);

    const getPossibleSelectableSteps = useCallback(() => {
        addLOBStepsToDisplayMappings();
        return stepToDisplayName;
    }, [addLOBStepsToDisplayMappings]);

    const [detailsLoaded, setDetailsLoaded] = useState(false);
    const [policyDetails, setPolicyDetails] = useState({});
    //US993539
    const [isUWIssuesPanelVisible, setIsUWIssuesPanelVisible] = useState(true);

    const jobNumber = endorsementVM.jobID.value;
    const gpaMode = !!endorsementVM.isSubmitAgent.value;
    const ampMode = !gpaMode;
    const primaryNamedInsuredFirstName = endorsementVM.baseData.primaryNamedInsuredFirstName_ML.value;
    // eslint-disable-next-line no-secrets/no-secrets
    const isOOSConflict = _.get(endorsementVM, 'isOutOfSequenceConflict_ML.value');
    const isAgent = appConfig.portalCode === 'GPA';
    const premiumCurrentAmount = endorsementVM.previousTotalCost.value;
    const premiumAdjustedAmount = endorsementVM.totalCost.value;
    const premiumDifferenceAmount = endorsementVM.transactionCost.value;
    const fullTermCost = endorsementVM.fullTermCost_Ext.value;
    const termTypeDisplayKey = termTypes[endorsementVM.value.baseData.termType_ML];
    const isModernProduct = _.get(endorsementVM, 'isModernProduct_Ext.value', false);

    const productCode = _.get(endorsementVM, 'baseData.productCode.value', '');
    const hoCoveragePartType = _.get(endorsementVM, 'lobData.homeowners.coverables.coveragePartType_ML.value.code', '');
    const isAuto = MLProductCodeUtil.isPersonalAuto(productCode);
    const isHomeowners = MLProductCodeUtil.isHomeOwnersPartialTypeHome(hoCoveragePartType);
    const isCondo = MLProductCodeUtil.isHomeOwnersPartialTypeCondo(hoCoveragePartType);
    const isRenters = MLProductCodeUtil.isHomeOwnersPartialTypeRental(hoCoveragePartType);
    const isLandlordProduct = MLProductCodeUtil.isHomeOwnersPartialTypeLandlordHome(productCode)
        || MLProductCodeUtil.isHomeOwnersPartialTypeLandlordCondo(productCode);
    const isUmbrellaProduct = MLProductCodeUtil.isPersonalUmbrella(productCode);

    let wizardConfig = paWizardConfig;
    if (MLProductCodeUtil.isPersonalAuto(productCode)) {
        wizardConfig = paWizardConfig;
    } else if (MLProductCodeUtil.isHomeOwners(productCode)) {
        wizardConfig = hoWizardConfig;
    } else if (MLProductCodeUtil.isPersonalUmbrella(productCode)) {
        wizardConfig = pupWizardConfig;
    }

    const { steps } = wizardConfig;

    const availableAddlChanges = useMemo(() => {
        const filteredSteps = steps.filter((step) => {
            if (_.get(step, 'stepProps.isStartingPointML', false) || step.mlStepName === 'endorsementPaListExcludedDrivers' || step.mlStepName === 'endorsementPupListExcludedVehicleOperators') {
                step.label = step.stepProps.stepButtonLabelML ? translator(step.stepProps.stepButtonLabelML) : translator(step.title);
                return true;
            }
            return false;
        });
        return _.orderBy(filteredSteps, 'label');
    }, [steps, translator]);

    const goToStep = useCallback((stateName) => {
        const indexOfState = _.findIndex(
            currentSteps,
            ({ path }) => path === stateName
        );
        jumpTo(indexOfState);
    }, [jumpTo, currentSteps]);

    const isDeviceRemoved = () => {
        if (endorsementVM.lobData.homeowners && endorsementVM.lobData.homeowners.constructionDetails_ML && endorsementVM.lobData.homeowners.constructionDetails_ML.isDeviceRemovedAlert_ML) {
            return endorsementVM.lobData.homeowners.constructionDetails_ML.isDeviceRemovedAlert_ML.value;
        }
        return false;
    };

    const setDeviceAlert = () => {
        const successMsg = translator(messages.deviceRemovedMsg);
        clearBlockAlerts('deviceRemoved');
        if (isDeviceRemoved()) {
            addSuccessAlert(successMsg, 'deviceRemoved');
        }
    };

    const hasCoverageChanges = () => {
        return !!endorsementVM.isCoverageChanged_ML.value;
    };

    const coverageAlert = () => {
        clearBlockAlerts('coverageChanges');
        if (hasCoverageChanges()) {
            const warningMsg = (
                <FormattedMessage
                    {...messages.coverageChangesWarningMsg}
                    values={{
                        message1: <strong>{ translator(messages.autoChgOccured) }</strong>,
                        message2: translator(messages.checkPolicyBelow)
                    }}
                />
            );
            addWarningAlert(warningMsg, 'coverageChanges');
        }
    };

    const oosConflictAlert = () => {
        clearBlockAlerts('oosConflict');

        if (isOOSConflict && isAgent) {
            const errorMsg = (
                <FormattedMessage
                    {...messages.unableToProceedCallAgency}
                    values={{
                        message1: <strong>{ translator(messages.conflictsPriorChange) }</strong>,
                        message2: translator(messages.callAgency)
                    }}
                />
            );

            addErrorAlert(errorMsg, 'oosConflict');
        }
    };

    const coverageLevelAlert = () => {
        clearBlockAlerts('coverageLevelChanges');
        const covLevChg = endorsementVM.changeCoverageLevel_Ext.value;
        if (covLevChg) {
            const covLevelWarningMsg = translator(messages.coverageLevelChangeWarningMsg, {strong: (chunks) => <strong>{chunks}</strong>, newCoverageLevel: covLevChg});
            const addedCoverages = _.get(endorsementVM, "value.levelChangeCoverages_ML.addedCoverages");
            const removedCoverages = _.get(endorsementVM, "value.levelChangeCoverages_ML.removedCoverages");
            const updatedCoverages = _.get(endorsementVM, "value.levelChangeCoverages_ML.updatedCoverages");
            let changedCoveragesMessage;
            let numberedList;
            if (!_.isUndefined(addedCoverages)) {
                changedCoveragesMessage = translator(messages.coverageLevelChangeWarningAddedCovsMsg, {div: (chunks) => <div>{chunks}</div>});
                numberedList = addedCoverages.map((item, index) => <div>{index + 1}. {item}</div>);
            } else if (!_.isUndefined(removedCoverages)) {
                changedCoveragesMessage = translator(messages.coverageLevelChangeWarningRemovedCovsMsg, {div: (chunks) => <div>{chunks}</div>});
                numberedList = removedCoverages.map((item, index) => <div>{index + 1}. {item}</div>);
            } else if (!_.isUndefined(updatedCoverages)) {
                changedCoveragesMessage = translator(messages.coverageLevelChangeWarningUpdatedCovsMsg, {div: (chunks) => <div>{chunks}</div>});
                numberedList = updatedCoverages.map((item, index) => <div>{index + 1}. {item}</div>);
            }
            const finalWarningMessage = [covLevelWarningMsg, changedCoveragesMessage, numberedList];
            addWarningAlert(finalWarningMessage, 'coverageLevelChanges');
        }
    };

    const clearPerilAlerts = useCallback(() => {
        clearBlockAlerts('windHail');
        clearBlockAlerts('roofLoss');
        clearBlockAlerts('allOtherPeril');
        clearBlockAlerts('grcAvailable');
    }, [clearBlockAlerts]);

    const setPerilAlerts = useCallback((warnings) => {
        clearPerilAlerts();

        if (!_.isEmpty(warnings)) {
            if (warnings.includes("WindHail")) {
                addWarningAlert(messages.windstormHailDeductibleBumpedWarning, "windHail");
            }

            if (warnings.includes("MinRoofAge")) {
                addWarningAlert(messages.roofLossSettlementBumpedWarning, "roofLoss");
            }

            if (warnings.includes("AllOtherPeril")) {
                addWarningAlert(messages.allOtherPerilBumpedWarning, "allOtherPeril");
            }

            if (warnings.includes("GRCAvailable")) {
                addWarningAlert(messages.grcAvailableBumpedWarning, "grcAvailable");
            }
        }
    }, [addWarningAlert, clearPerilAlerts]);

    const showPremiumChangedAlert = useCallback(() => {
        if ((endorsementVM.value.isPersonalAuto() || endorsementVM.value.isPersonalUmbrella()) && MLDisclosureUtil.isRequotedAfterMvr(endorsementVM.jobID.value)) {
            addWarningAlert(messages.premiumChangedAfterVehicleMvrWarning, 'premiumChanged');
        }
    }, [endorsementVM.value, endorsementVM.jobID.value, addWarningAlert]);

    const driverMaritalStatusWarning = () => {
      if (isAuto) {
        let policyDrivers = _.get(
          endorsementVM,
          "lobData.personalAuto.coverables.drivers.value",
          []
        );
        filterDriverAndDisplayWarning(policyDrivers);
      }
      if (isUmbrellaProduct) {
        let vehicleOperators = _.get(
          endorsementVM,
          "lobData.personalUmbrella.coverables.vehicleOperators.value",
          []
        );
        filterDriverAndDisplayWarning(vehicleOperators);
      }
    };

    const filterDriverAndDisplayWarning = (policyDrivers) => {
        let maritalStatus = ["M", "C"];
        let pniStatus = policyDrivers.filter(
          (operator) =>
            (operator.relationshipToInsured === "self" || operator.relationshipToInsured_ML === "self") &&
            !maritalStatus.includes(operator.maritalStatus_Ext || operator.maritalStatus_ML)
        );
        let spouseStatus = policyDrivers.filter(
          (operator) =>
            (operator.relationshipToInsured === "spouse" || operator.relationshipToInsured_ML === "spouse") &&
            !maritalStatus.includes(operator.maritalStatus_Ext || operator.maritalStatus_ML)
        );
        if (pniStatus.length === 1 && spouseStatus.length === 1) {
          addWarningAlert(
            messages.maritalStatusRelationshipWarning,
            "maritalStatusRelationshipWarning"
          );
        }
    }

    useEffect(() => {
        if (saveAndQuoted) {
            const policyDetailsPromise = EndorsementService.getPolicyChangeDetails(endorsementVM?.jobID?.value, authHeader);
            showProgressDialog(platformMessages.getPolicyDetails, policyDetailsPromise);
            policyDetailsPromise.then((details) => {
                const policyDetailsDTOML = viewModelService.create(
                    details,
                    'pc',
                    'metlife.edge.capabilities.policy.dto.PolicyDetailsDTOML'
                );
                setPolicyDetails(policyDetailsDTOML);
                setDetailsLoaded(true);
            }).catch(_.noop);

            const trackingData = MLNavigationStepsTrackingService.getData();
            if (trackingData && trackingData.dynamicSteps && trackingData.dynamicSteps.length > 0) {
                MLNavigationStepsTrackingService.addToDynamicSteps(translator(messages.updatedQuotePremium), false, currentStepName, authHeader);
            }

            setDeviceAlert();
            coverageAlert();
            oosConflictAlert();
            coverageLevelAlert();
            const bumpedPerils = endorsementVM?.perilBumpedCoverages_Ext?.value;
            setPerilAlerts(bumpedPerils);
            showPremiumChangedAlert();
            driverMaritalStatusWarning();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [saveAndQuoted]);

    const savePremiumAndNavigate = () => {
        const jsonData = {total: endorsementVM.value.totalCost};
        MLPortalStorageService.store(endorsementVM.value.jobID, null, ML_STORAGE_KEY_PREVIOUS_PREMIUM, JSON.stringify(jsonData), authHeader).then(() => {
            MLNavigationStepsTrackingService.completeAllDynamicSteps(authHeader);
            MLTagManagerService.sendFormStepPolicyChangeStep();
            onNext();
        });
    };

    const shouldShowDriverExclusionAgreement = useCallback(async () => {
        const policyStateCode = endorsementVM.baseData.policyAddress.state.value.code;
        const isStateOR = policyStateCode === 'OR';

        const response = await MLPortalStorageService.retrieve(
            endorsementVM.jobID.value,
            null,
            ML_STORAGE_KEY_SHOW_EXCLUSION_AGREEMENT,
            authHeader
        );

        const policyDrivers = _.get(
            endorsementVM,
            'lobData.personalAuto.coverables.drivers.value',
            []
        );

        let parsedResponse = {};
        try {
            parsedResponse = typeof response === 'string' ? JSON.parse(response) : response || {};
        } catch {
            parsedResponse = {};
        }

        const hasExcludedDrivers = policyDrivers.some(
            (d) =>
                d.type_ML === 'excluded' &&
                (d.fixedId === Number(parsedResponse.fixedId) || d.displayName === parsedResponse.displayName) &&
                ['unwanted', 'own_insurance', 'insure_driver', 'license_revoked', 'registeredowner', 'unabletodrive'].includes(parsedResponse.status_ML)
        );

        return isStateOR && hasExcludedDrivers;
    }, [endorsementVM, authHeader]);

    const showDriverExclusionAgreementModal = useCallback(() => {
        const disableButton = () => {
            return _.get(endorsementVM, "lobData.personalAuto.excludedDriverScriptAgree_Ext.value") === undefined;
        };

        const onSaveAction = async (subVM) => {
            const agree = subVM.lobData.personalAuto?.excludedDriverScriptAgree_Ext.value;
            if (agree === true) {
                // continue with excluded drivers
                goNext();
            } else {
                // change excluded drivers to non drivers and requote
                const policyDrivers = _.get(endorsementVM, "lobData.personalAuto.coverables.drivers.value", []);
                const response = await MLPortalStorageService.retrieve(
                    endorsementVM.jobID.value,
                    null,
                    ML_STORAGE_KEY_SHOW_EXCLUSION_AGREEMENT,
                    authHeader
                );

                let parsedResponse = {};
                try {
                    parsedResponse = typeof response === 'string' ? JSON.parse(response) : response || {};
                } catch {
                    parsedResponse = {};
                }
                const targetId = Number(parsedResponse?.fixedId);
                const targetName = parsedResponse?.displayName;
                if (targetId || targetName) {
                    policyDrivers.forEach((d) => {
                        if (d.type_ML === 'excluded' && (d.fixedId === targetId || d.displayName === targetName)) {
                            d.type_ML = 'nondriver';
                        }
                    });
                }

                    const promise = EndorsementService.saveAndQuote(endorsementVM.value, authHeader);
                    showProgressDialog(platformMessages.quotingPolicyChange, promise);
                    promise.then((responseData) => {
                        endorsementVM.value = new PolicyChange(responseData);
                        updateWizardData(wizardData);
                    }).catch((error) => {
                        showErrorModal(platformMessages.errorSavingQuote, error);
                    });
            }
            await MLPortalStorageService.store(endorsementVM.value.jobID, null, ML_STORAGE_KEY_SHOW_EXCLUSION_AGREEMENT, JSON.stringify({}), authHeader)
        };

        const overrides = {
            descriptionText: {
                content: translator(DriverExclusionAgreementPopupMessages.driverExclusionAgreementPopupContent, {
                    li: (chunks) => <li>{chunks}</li>,
                    ol: (chunks) => <ol>{chunks}</ol>,
                    ratedPremium: formatCurrency(intl, {
                        value: endorsementVM?.premium?.ratedLiabilityPremium_Ext?.amount?.value,
                        currency: 'usd',
                        showFractions: false,
                        placeholder: '$0'
                    }),
                    excludedPremium: formatCurrency(intl, {
                        value: endorsementVM?.premium?.excludedLiabilityPremium_Ext?.amount?.value,
                        currency: 'usd',
                        showFractions: false,
                        placeholder: '$0'
                    })
                }
                )
            }
        };

        const componentProps = {
            title: translator(DriverExclusionAgreementPopupMessages.driverExclusionAgreementPopupHeader),
            uiProps: DriverExclusionAgreementPopup.pageContent,
            actionBtnLabel: platformMessages.mlContinue,
            cancelBtnLabel: platformMessages.mlCancel,
            viewModel: endorsementVM,
            disableButton,
            modalBodyStyles: DriverExclusionAgreementPopupStyles,
            overrideProps: overrides,
            onSaveAction,
            showXCloseButton: true
        }

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).then(() => {
            return true;
        }).catch(() => {
            return false;
        });
    }, [authHeader, goNext, modalApi, showProgressDialog, translator]);

    const onSubmitChangesClick = async () => {
        if (endorsementVM.value.isPersonalUmbrella()) {
            const removeNewUnderlyingPolicy =
                endorsementVM.lobData.personalUmbrella.underlyingPolicies.value.findIndex(
                    (policy) => policy.ulPolicyFixID === 'new'
                );

            if (removeNewUnderlyingPolicy > -1) {
                endorsementVM.lobData.personalUmbrella.underlyingPolicies.value.splice(removeNewUnderlyingPolicy, 1);
            }
        }

        if (await shouldShowDriverExclusionAgreement()) {
            showDriverExclusionAgreementModal();
            return;
        }

        clearAlerts();
        savePremiumAndNavigate();
    };

    const onEditEffectiveDateClick = () => {
        endorsementVM.value.editEffectiveDate = true;
        goToStep(EFFECTIVE_DATE_STATE);
    };

    const isSubmitChangesDisabled = () => {
        return endorsementVM.value.blockNavigation_ML === true || !detailsLoaded || endorsementVM.value?.validationErrors_ML?.length || isFileUploadDone;
    };

    const emailQuote = (sessionInfo, isBundleProposal) => {
        const emailPromise = EndorsementService.emailQuote(sessionInfo, isBundleProposal, authHeader);
        showProgressDialog(platformMessages.generatingQuoteProposal, emailPromise);

        emailPromise.then(() => {
            modalApi.showAlert({
                title: '',
                message: translator(messages.emailQuoteSuccessMsg, {emailAddress: sessionInfo.emailAddress1}),
                status: 'info',
                icon: 'mi-error-outline'
            }).catch(_.noop);
        }, () => {
            showErrorModal(platformMessages.error, messages.proposeQuoteErrorMsg);
        });
    };

    const printQuote = useCallback((quoteID) => {
        // EventHub.publish('wizard', 'print');
        const createProposalPromise = EndorsementService.createQuoteProposal(quoteID, authHeader);
        showProgressDialog(platformMessages.generatingQuoteProposal, createProposalPromise);
        createProposalPromise.then((data) => {
            const docUid = data.docUID;
            const sessionId = data.sessionID;
            const publicId = data.publicID;
            if (docUid) {
                const resp = GatewayDocumentService.downloadDocument(publicId, sessionId);
                showProgressDialog(platformMessages.downloadingDocument, resp);
                resp.catch((error) => {
                    console.error(error);
                    showErrorModal(platformMessages.error, platformMessages.unableToDownloadDocument);
                });
            } else {
                showErrorModal(platformMessages.error, messages.proposeQuoteErrorMsg);
            }
        });
    }, [authHeader, showErrorModal, showProgressDialog]);

    const createProposalForAgentType = (currentUser, quoteID, email, isBundled) => {
        if (currentUser.isGCSSales) {
            const sessionInfo = {
                quoteID: quoteID,
                sessionID: endorsementVM.sessionUUID.value,
                emailAddress1: email,
                sendType_ML: 'email',
                completedQuote_ML: true
            };
            emailQuote(sessionInfo, isBundled);
        } else {
            printQuote(quoteID, isBundled);
        }
    };

    const createProposal = (quoteID, email, isBundled) => {
        UserService.getCurrentUser(authHeader).then((user) => {
            createProposalForAgentType(user, quoteID, email, isBundled);
        });
    };

    const createEndorsementProposal = (quoteID, email, isBundled) => {
        createProposal(quoteID, email, isBundled);
    };

    const openCoveragePackageLevelModal = () => {
        const componentProps = {
            title: messages.offeringDefinitionsLabel,
            overrideProps: {
                isPersonalAuto : isAuto,
                isHomeowners,
                isRenters,
                isCondo
            },
            CustomComponent: MLCoveragePackageLevelInfoModal,
            actionBtnLabel: commonMessages.close,
            showFooterOnCustomComponent: true
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const getCoveragePackageLevelContent = () => {
        return (
            <Button type="text" onClick={openCoveragePackageLevelModal}>COVERAGE LEVEL</Button>
        );
    };

    const getPremiumTableOverrides = () => {
        const overrides = {
            premiumTable: {
                data: [{}]
            },
            premiumCurrentAmount: {
                renderCell: () => {
                    return (
                        <CurrencyValue currency={premiumCurrentAmount.currency} value={premiumCurrentAmount.amount} suffix={` /${translator(termTypeDisplayKey)}`} showFractions />
                    );
                }
            },
            premiumDifferenceAmount: {
                renderCell: () => {
                    return (
                        <CurrencyValue tag='strong' currency={_.get(premiumDifferenceAmount, 'currency', 'USD')} value={_.get(premiumDifferenceAmount, 'amount', 0)} suffix={` /${translator(termTypeDisplayKey)}`} showFractions />
                    );
                }
            },
            premiumAdjustedAmount: {
                renderCell: () => {
                    return (
                        <CurrencyValue tag='strong' currency={_.get(premiumAdjustedAmount, 'currency', 'USD')} value={_.get(premiumAdjustedAmount, 'amount', 0)} suffix={` /${translator(termTypeDisplayKey)}`} showFractions />
                    );
                }
            },
            fullTermCost: {
                renderCell: () => {
                    return (
                        <CurrencyValue tag='strong' currency={_.get(fullTermCost, 'currency', 'USD')} value={_.get(fullTermCost, 'amount', 0)} suffix={` /${translator(termTypeDisplayKey)}`} showFractions />
                    );
                }
            }
        };
        return overrides;
    };

    const jumpToSteps = useCallback((newStepId) => {
        MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepId, currentSteps, currentStepIndex, changeNextSteps, goNext, productCode);
    }, [changeNextSteps, currentStepIndex, currentSteps, goNext, productCode]);
    // ============== AMP navigation methods ======================

    const onEditDriversClick = () => {
        jumpToSteps(PA_DRIVERS_STEP);
    };

    const onEditVehiclesClick = () => {
        jumpToSteps(PA_VEHICLES_STEP);
    };

    const onEditTrailerCamperClick = () => {
        jumpToSteps(PA_RENTED_TRAILER_CAMPER_STEP);
    }

    const onEditCoveragesClick = () => {
        if (MLProductCodeUtil.isPersonalAuto(productCode)) {
            jumpToSteps(PA_COVERAGE_STEP);
        } else {
            jumpToSteps(NON_PA_COVERAGE_STEP);
        }
    };

    const onChangePaymentMethodClick = () => {
        if (MLProductCodeUtil.isPersonalAuto(productCode)) {
            jumpToSteps(PA_PAYMENT_STEP);
        } else if (MLProductCodeUtil.isHomeOwners(productCode)) {
            jumpToSteps(HO_PAYMENT_STEP);
        } else {
            jumpToSteps(PUP_PAYMENT_STEP);
        }
    };

    const onDeleteAllChanges = () => {
        const withdrawAndGoPoliciesPage = () => {
            MLTagManagerService.sendLinkClickEvent('Discard All Changes');
            const withdrawPromise = EndorsementService.withdrawEndorsement([policyDetails.value.jobID], authHeader);
            showProgressDialog(messages.withdrawingPolicyChange, withdrawPromise);
            history.push('/policies');
        };

        const componentProps = {
            title: translator(messages.confirmationTitle),
            actionBtnLabel: messages.yes,
            cancelBtnLabel: messages.cancel,
            simpleMessage: translator(messages.confirmationDesc),
            closeSimpleMessage: false
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).then(withdrawAndGoPoliciesPage);
    };

    const onMakeMoreChangesClick = () => {
        goToStep(ADDITIONAL_CHANGES_STATE);
    };
    // ==========================================

    const formatAmountString = useCallback((amount) => {
        try {
            return intl.formatNumber(amount.amount, { style: 'currency', currency: amount.currency });
        } catch (e) {
            return '';
        }
    }, [intl]);

    const isPersonalAuto = (details) => {
        return _.get(details, 'lines.value', []).some((line) => MLLineTypeUtil.isPersonalAuto(line));
    };

    const isHomeOwners = (details) => {
        return _.get(details, 'lines.value', []).some((line) => MLLineTypeUtil.isHomeOwners(line));
    };

    const isPersonalUmbrella = (details) => {
        return _.get(details, 'lines.value', []).some((line) => MLLineTypeUtil.isPersonalUmbrella(line));
    };

    const getSummaryComponentOverrides = () => {
        let overrides = {};
        if (isPersonalAuto(policyDetails)) {
            overrides = {
                policySummaryComponent: {
                    value: policyDetails,
                    editDrivers: onEditDriversClick,
                    editVehicles: onEditVehiclesClick,
                    editCoverages: onEditCoveragesClick,
                    editPayment: onChangePaymentMethodClick,
                    editTrailerCamper: onEditTrailerCamperClick,
                    editEffectiveDate: onEditEffectiveDateClick,
                    cancelChanges: onDeleteAllChanges,
                    makeMoreChanges: onMakeMoreChangesClick,
                    currentSteps,
                    currentStepIndex,
                    goToStep: (path) => goToStep(path),
                    selectablePath: getPossibleSelectableSteps(),
                    submitChanges: onSubmitChangesClick,
                    detailsLoaded,
                    gpaMode,
                    ampMode,
                    isPolicyChange: true,
                    isModernProduct
                }
            };
        } else if (isHomeOwners(policyDetails)) {
            overrides = {
                policySummaryComponent: {
                    value: policyDetails,
                    editCoverages: onEditCoveragesClick,
                    editPayment: onChangePaymentMethodClick,
                    editEffectiveDate: onEditEffectiveDateClick,
                    cancelChanges: onDeleteAllChanges,
                    makeMoreChanges: onMakeMoreChangesClick,
                    currentSteps,
                    currentStepIndex,
                    goToStep: (path) => goToStep(path),
                    selectablePath: getPossibleSelectableSteps(),
                    submitChanges: onSubmitChangesClick,
                    detailsLoaded,
                    gpaMode,
                    ampMode,
                    isPolicyChange: true,
                    isModernProduct
                }
            };
        } else if (isPersonalUmbrella(policyDetails)) {
            overrides = {
                policySummaryComponent: {
                    value: policyDetails,
                    editDrivers: onEditDriversClick,
                    editCoverages: onEditCoveragesClick,
                    editPayment: onChangePaymentMethodClick,
                    editEffectiveDate:   onEditEffectiveDateClick,
                    cancelChanges: onDeleteAllChanges,
                    makeMoreChanges: onMakeMoreChangesClick,
                    currentSteps,
                    currentStepIndex,
                    goToStep: (path) => goToStep(path),
                    selectablePath: getPossibleSelectableSteps(),
                    submitChanges: onSubmitChangesClick,
                    detailsLoaded,
                    gpaMode,
                    ampMode,
                    isPolicyChange: true,
                    isModernProduct
                }
            };
        }

        return overrides;
    };

    const getSummaryComponentResolver = () => {
        let resolver = {};
        if (isPersonalAuto(policyDetails)) {
            resolver = { policySummaryComponent: PAPolicySummaryComponent };
        }

        if (isHomeOwners(policyDetails)) {
            resolver = { policySummaryComponent: HOPolicySummaryComponent };
        }

        if (isPersonalUmbrella(policyDetails)) {
            resolver = { policySummaryComponent: PUPPolicySummaryComponent };
        }

        return resolver;
    };

    const getAMPHeaderText = () => {
        if (isPersonalAuto(policyDetails)) {
            return messages.ampPAHeaderText;
        }
        if (isPersonalUmbrella(policyDetails)) {
            return messages.ampPUPHeaderText;
        }
        if (isHomeOwners(policyDetails)) {
            return messages.ampDwellingHeaderText;
        }

        return "";
    };
    const toggleUWIssuesPanel = () => {
        setIsUWIssuesPanelVisible(!isUWIssuesPanelVisible);
    }; 

    const overrideProps = {
        agentSummaryContainer: {
            visible: gpaMode
        },
        ampSummaryContainer: {
            visible: ampMode && saveAndQuoted
        },
        ampPolicyChangeHeader: {
            content: translator(getAMPHeaderText())
        },
        ampPolicyChangeSectionHeader: {
            content: translator(messages.ampSubHeaderText, {name: endorsementVM.value.baseData.primaryNamedInsuredFirstName_ML, amount: formatAmountString(endorsementVM.value.transactionCost)})
        },
        agentMessage: {
            visible: gpaMode
        },
        policyChangeHeaderEffectiveDate: {
            content: (
                <FormattedMessage
                    {...messages.effectiveDateMsg}
                    values={{
                        effectiveDate: <strong>{ translator(messages.effectiveDate) }</strong>,
                        date: intl.formatDate(LocalDateUtil.toMidnightDate(endorsementVM.baseData.effectiveDate.value), { year: 'numeric', month: '2-digit', day: '2-digit' })
                    }}
                />
            )
        },
        MLUWIssuesPanelComponent:{
            visible:contingencies.length > 0
        },
        showRefreshLoadingDiv: {
            visible: false
        },
        refreshLoadingButton: {
            visible: true,
        },
        uwWrapperNonRefer:{
            visible: isUWIssuesPanelVisible
        },
        uwIssuesPanelLink:{
            visible: true,
            content: isUWIssuesPanelVisible ? translator(messages.hideAllIssues) : translator(messages.showAllIssues)
        },
        nonReferUwIssueIterableComponennt: {
            content: [(
            <div>
                {
                    contingencies?.map((value) => {
                    return (
                        <div id="parentUwIssueItemNonRefer" className="uw-issue">
                            <div id="spanContainer">
                                <span id="reasonP" className="body-copy font-weight-bold">
                                    {"Contingency :"}
                                </span>
                                <p id="showBundleIssues" className="body-copy display-inline-block"></p>
                                <p id="descrP" className="body-copy display-inline-block">
                                    {value.description_ML}
                                </p>
                                <span
                                    id="btnDividerSpanNonRefer"
                                    className="uw-issue-button-divider"
                                >{" "}</span>
                                <a
                                    id="uploadProofBtn"
                                    type="button"
                                    onClick={(e) => onUploadDocumentClicked(value)}
                                    className="vertical-spacing-0"
                                >
                                    {"Upload Proof"}
                                </a>
                            </div>
                        </div>
                    );
                })
                }
            </div>
            )]
        },
        policyChangeHeaderEditEffectiveDate: {
            onClick: onEditEffectiveDateClick
        },
        ...getPremiumTableOverrides(),
        submitChangesButton: {
            disabled: isSubmitChangesDisabled(),
            onClick: onSubmitChangesClick
        },
        saveAsDraftButton: {
            onClick: () => {
                window.location.href = `${window.location.origin}/producer-engage/policies/${endorsementVM.policyNumber.value}/summary`;
            },
            mlTagManagerLinkClick: "Updated Quote Premium_Save as draft"
        },
        quoteProposalButton: {
            onClick: () => createEndorsementProposal(jobNumber, endorsementVM.baseData.policyContact_ML.value.emailAddress1, false),
            mlTagManagerLinkClick: "Updated Quote Premium_Quote Proposal"
        },
        makeMoreChangesButton: {
            policyNumber: endorsementVM.policyNumber.value,
            productCode,
            changeSteps: getMoreChangesSelectableSteps(),
            jumpToInProgressStep: (stepPath) => {
                const step = availableAddlChanges.find((st) => st.path === stepPath);
                MLEndorsementFlowUtil.addAndNavigateToNewStep(step, currentSteps, currentStepIndex, changeNextSteps, goNext);
            },
            buttonClassName: 'display-inline-block vertical-spacing-20',
            label: translator(messages.makeMoreChanges),
            canAccessGroup,
            isSummaryPage : true,
            visible: (additionalPolicyChangeProps.isPolicyChangeAndTrasferToPayrollFlow !== true)
        },
        coveragePackageLevelLabel: {
            visible: !isUmbrellaProduct && !isLandlordProduct && !endorsementVM.isModernProduct_Ext?.value,
            content: getCoveragePackageLevelContent()
        },
        policyDetailsContainer: {
            className: gpaMode ? "vertical-spacing-10 ml-section" : "vertical-spacing-10"
        },
        policySummaryComponent: {
            visible: false
        },
        ...getSummaryComponentOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onToggleUWIssuesPanel: toggleUWIssuesPanel,
            onRefreshPreBind: refreshPreBindContingencyData,
        },
        resolveComponentMap: {
            MLPolicyChangeBtnComponent,
            ...getSummaryComponentResolver()
        },
        resolveClassNameMap: styles
    };
    //US993539
    const onUploadDocumentClicked = useCallback((contingency) => {
        openAddNoteDialog(contingency);
    }, []);

    const openAddNoteDialog = (contingency) => {
        let policyInfo = endorsementVM.value
        const componentProps = {
            showHeader: false,
            uiProps: mlDocumentsUploadPopupMetadata.componentContent,
            actionBtnLabel: _.upperCase(translator(MLDocumentsUploadPopupMsg.continue)),
            cancelBtnLabel: MLDocumentsUploadPopupMsg.cancelModal,
            disableButton: (vm) => !(_.get(vm, 'aspects.valid') && vm, _.get(vm, 'aspects.subtreeValid')),
            viewModelService,
            authHeader,
            CustomComponent: MLDocumentsUpload,
            overrideProps: {
                policyNumber: endorsementVM.policyNumber.value,
                isAgent: true,
                policy: policyInfo,
                contingencyName: contingency?.title,
                isFromPolicyChangeScreen:true,
                contingency
            },
            onSaveAction: () => {
                return false;
            },
            buttonType: 'secondary'
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
};

PolicyChangeSummaryComponent.propTypes = {
    endorsementVM: PropTypes.shape({}).isRequired,
    jumpTo: PropTypes.func.isRequired,
    currentSteps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    currentStepIndex: PropTypes.number.isRequired,
    changeNextSteps: PropTypes.func.isRequired,
    goNext: PropTypes.func.isRequired
};

export default withRouter(PolicyChangeSummaryComponent);
